import { createRouter, createWebHistory } from "vue-router";
import { getCurrentUser } from "aws-amplify/auth";
import Login from "./views/Login.vue";
import AppShell from "./components/AppShell.vue";
import Producten from "./views/Producten.vue";
import ProductEditor from "./views/ProductEditor.vue";
import Voorraad from "./views/Voorraad.vue";
import Categorieen from "./views/Categorieen.vue";
import CategoryEditor from "./views/CategoryEditor.vue";
import Bestellingen from "./views/Bestellingen.vue";
import BestellingDetail from "./views/BestellingDetail.vue";
import Klanten from "./views/Klanten.vue";
import KlantDetail from "./views/KlantDetail.vue";
import Checkouts from "./views/Checkouts.vue";
import CheckoutDetail from "./views/CheckoutDetail.vue";
import Instellingen from "./views/Instellingen.vue";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", component: Login },
    {
      path: "/",
      component: AppShell,
      children: [
        { path: "", redirect: "/producten" },
        { path: "producten", component: Producten },
        { path: "producten/nieuw", component: ProductEditor },
        { path: "producten/:id/bewerken", component: ProductEditor },
        { path: "voorraad", component: Voorraad },
        { path: "categorieen", component: Categorieen },
        { path: "categorieen/nieuw", component: CategoryEditor },
        { path: "categorieen/:id/bewerken", component: CategoryEditor },
        { path: "bestellingen", component: Bestellingen },
        { path: "bestellingen/:id", component: BestellingDetail },
        { path: "klanten", component: Klanten },
        { path: "klanten/:id", component: KlantDetail },
        { path: "checkouts", component: Checkouts },
        { path: "checkouts/:id", component: CheckoutDetail },
        { path: "instellingen", component: Instellingen },
      ],
    },
  ],
});

// Auth-guard: alles behalve /login vereist een ingelogde sessie.
router.beforeEach(async (to) => {
  if (to.path === "/login") return true;
  try {
    await getCurrentUser();
    return true;
  } catch {
    return "/login";
  }
});
